module.exports = __webpack_public_path__ + "static/media/partner-fit-white.9651ece8.svg";